<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :showAdd="showAdd"
            :multiple="multiple"
            :autoComplete="autoComplete"
            :dense="dense"
            @change="$emit('change', $event)"
        />

        <sys-discipline-unsanitary-type-register @onCompleted="newItem" :model="{}" :show.sync="showForm" />


    </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
    name: 'SysSelectUnsanitaryType',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        multiple: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        }
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },
    },
    methods: {
        ...mapActions('discipline', ['ActionIndexUnsanitaryTypes']),        
        
        async getItems() {

            this.loading = true;

            await this.ActionIndexUnsanitaryTypes()
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

    newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
            }
        }
    },
    
}
</script>